var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"img-fluid rotate",attrs:{"src":require("@/assets/logo-emp.png"),"alt":"Logo loading","width":"150"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }